import React, { Component } from 'react';
import resources from '../../resources';
import TextSection from '../BaseComponents/TextSection';
import TextSection2 from '../BaseComponents/TextSection2';
import TextSectionWithStructuredBullets from '../BaseComponents/TextSectionWithStructuredBullets';
import ImageBulletedSection from '../BaseComponents/ImageBulletedSection';
import StoreManager from '../../appdata';
import languages from '../../appdata/languages';

class MacroeconomicOverviewContent extends Component {
  render() {

    const lang = StoreManager.appState.thisApp.state.currentLanguage;
    const content = languages[lang].MacroeconomicOverviewContent;
    const { isMobile } = StoreManager.appState.thisApp.state

    return (
      <div>
        <h2 style={{  fontFamily: 'Inter28-SemiBold', fontSize: isMobile ? 24 : 36, fontWeight: 500, marginBottom: 24 }}>
          {content.title}
        </h2>
        <TextSection title={content.section1Title} paragraphs={content.section1TextArray} />
        <TextSection title={content.section2Title} paragraphs={content.section2TextArray} />
        <div style={{
          backgroundImage: `url(${resources.images.MacroeconomicOverviewImageBG})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          borderRadius: 16,
          marginTop: 80,
          padding: '40px 24px',
          color: 'white'
        }}>
          <div style={{ marginBottom: 16 }}>
            <img
              src={lang == 'vi' ? resources.images.MacroeconomicOverviewImage1_vi : resources.images.MacroeconomicOverviewImage1}
              style={{
                width: '100%',
                borderRadius: 8,
                objectFit: 'cover'
              }}
            />
          </div>
          <TextSection2 title={content.section3Title} paragraphs={content.section3TextArray} />
          <TextSection2 title={content.section4Title} paragraphs={content.section4TextArray} />
          <TextSection2 title={content.section5Title} paragraphs={content.section5TextArray} />
          <div style={{ height: 60 }}></div>
        </div>
        <TextSection title={content.section6Title} paragraphs={content.section6TextArray} />
        <img
          src={lang == 'vi' ? resources.images.MacroeconomicOverviewImage2_vi : resources.images.MacroeconomicOverviewImage2}
          style={{
            width: '100%',
            borderRadius: 8,
            objectFit: 'cover'
          }}
        />
        <TextSection title={content.section7Title} paragraphs={content.section7TextArray} />
        <TextSection title={content.section8Title} paragraphs={content.section8TextArray} />
        <TextSection title={content.section9Title} paragraphs={content.section9TextArray} />
        <img
          src={lang == 'vi' ? resources.images.MacroeconomicOverviewImage3_vi : resources.images.MacroeconomicOverviewImage3}
          style={{
            width: '100%',
            borderRadius: 8,
            objectFit: 'cover'
          }}
        />

      </div>
    );
  }
}

export default MacroeconomicOverviewContent;
